<div class="page-wrapper">
  @if (isLoaded) {
    <i-navbar
      [config]="navbarConfig"
      [autoCollapse]="true"
      [collapsable]="true"
      (langChange)="receive_langChg($event)"
      (openNotification)="markAllNotificationsAsRead()">
      <router-outlet></router-outlet>
      <app-circular-menu></app-circular-menu>
    </i-navbar>
  }
</div>
